module.exports = __webpack_public_path__ + "static/img/5.53075fc3.png";